import { PointConfigRef } from '@src/types/Widget';
import { DataPointWithValue } from '@src/types/DataPoint';

interface FieldIdentifier {
  pointAlias: string;
  sourceDeviceId?: string;
  fieldName: string;
}

const FIELD_SEPARATOR = '@'; // More descriptive separator

export function createFieldIdentifier(
  pointConfigRef: PointConfigRef,
): FieldIdentifier {
  const pointAlias =
    pointConfigRef.pointAlias || pointConfigRef.pointName?.toLowerCase() || '';
  const sourceDeviceId = pointConfigRef.overrideSourceDeviceId;
  const fieldName = sourceDeviceId
    ? `${pointAlias}${FIELD_SEPARATOR}${sourceDeviceId}`
    : pointAlias;

  return { pointAlias, sourceDeviceId, fieldName };
}

export function getFieldNameFromDataPoint(
  dataPoint: DataPointWithValue,
): string {
  return createFieldIdentifier({
    pointAlias: dataPoint.pointAlias,
    overrideSourceDeviceId: dataPoint.overrideSourceDeviceId,
  } as PointConfigRef).fieldName;
}

// Helper to parse field name back to components if needed
export function parseFieldName(fieldName: string): {
  pointAlias: string;
  sourceDeviceId?: string;
} {
  if (typeof fieldName !== 'string' || fieldName.length === 0) {
    return { pointAlias: '', sourceDeviceId: undefined };
  }
  const parts = fieldName.split(FIELD_SEPARATOR);
  return {
    pointAlias: parts[0] || '',
    sourceDeviceId: parts[1] || undefined,
  };
}
